import { snackbarError } from 'reusable/mui/snackbar/snackbar'
import Loader from 'reusable/mobx-helpers/Loader'
import RegionRouterStore from 'features/main/RegionRouterStore'
import AuthStore from 'auth/AuthStore'
import { CacheHandler } from 'reusable/utils/cache'
import { defaultToken } from '@gap/utils/utils'

interface AuthValidateCustomTokenStoreParams {
   authStore: AuthStore
   regionRouterStore: RegionRouterStore
   token: string
   userId: string
   redirectUrl: string
   attemptSignIn: boolean
}

export default class AuthValidateCustomTokenStore {
   sp
   loader = new Loader()
   displayExpiredLink = false
   canRenewLink = false

   constructor(sp: AuthValidateCustomTokenStoreParams) {
      this.sp = sp
   }

   validateTokenAndRedirect = async () => {
      await this.loader.executeLoading(async () => {
         // Clear cache in case the user was logged in from a different org(ex. advisor user sending prework to self)
         CacheHandler.clearAll()

         if (this.sp.token === defaultToken) {
            // No token was set in the backend. We catch it here and skip the validation check. The redirectUrl should work without the auth validation
            return this.sp.regionRouterStore.navigate(this.sp.redirectUrl)
         }

         const validationResult = this.sp.attemptSignIn
            ? await this.sp.authStore.validateTokenAndAttemptSignIn(this.sp.token, this.sp.userId)
            : await this.sp.authStore.validateCustomTokenForUser(this.sp.token, this.sp.userId)

         switch (validationResult.status) {
            case 'invalid':
               // If we are in the password reset flow, and no token exists, that means the link has been used and cannot be used again
               if (window.location.pathname.includes('auth/update')) {
                  this.displayExpiredLink = true
               } else {
                  snackbarError('Invalid request')
               }
               break
            case 'expired':
               this.displayExpiredLink = true
               this.canRenewLink = true
               break
            case 'valid':
               this.sp.regionRouterStore.navigate(this.sp.redirectUrl)
               break
         }
      })
   }
}
